const PrivacyPolicy = () => {
  return (
    <div className="p-8 max-w-4xl mx-auto text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p><strong>Effective Date:</strong> 2025-06-18</p>
      <p><strong>Company:</strong> JRAutomation, BCE 1023951695</p>
      <p><strong>Contact:</strong> info@jrautomation.be</p>

      <h2 className="text-2xl font-semibold mt-6">1. Scope and Compliance</h2>
      <p>
        This privacy policy complies with the General Data Protection Regulation (GDPR) and the Belgian law of 30 July 2018 on the protection of individuals with regard to the processing of personal data.
      </p>

      <h2 className="text-2xl font-semibold mt-6">2. Data We Collect</h2>
      <ul className="list-disc ml-6">
        <li>Identification data: name, email address</li>
        <li>Professional data: company name, VAT number, job title</li>
        <li>Technical data: IP address, browser data, cookies</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">3. Purpose and Legal Basis</h2>
      <ul className="list-disc ml-6">
        <li>Contractual performance (Art. 6.1.b GDPR)</li>
        <li>Consent for marketing communications (Art. 6.1.a GDPR)</li>
        <li>Legitimate interest for internal analytics and fraud prevention (Art. 6.1.f GDPR)</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">4. Data Recipients</h2>
      <p>
        Your data may be shared with our accounting providers, software platforms, payment processors, or legal authorities if required.
      </p>

      <h2 className="text-2xl font-semibold mt-6">5. Data Retention</h2>
      <p>
        We retain your data as long as necessary to fulfill contractual and legal obligations. Afterwards, your data will be anonymized or securely deleted.
      </p>

      <h2 className="text-2xl font-semibold mt-6">6. Your Rights</h2>
      <p>
        You have the right to access, rectify, erase, restrict or object to the processing of your data. You can also request data portability or withdraw consent at any time.
      </p>
      <p>To exercise these rights, contact us at: <strong>info@jrautomation.be</strong></p>

      <h2 className="text-2xl font-semibold mt-6">7. Cookies</h2>
      <p>
        We use essential and analytical cookies. You may accept or decline non-essential cookies via our cookie banner. See our{" "}
        <a href="/cookie-policy.html" className="text-blue-600 hover:underline">
          Cookie Policy
        </a>{" "}
        for more details.
      </p>

      <h2 className="text-2xl font-semibold mt-6">8. Security</h2>
      <p>
        We implement technical and organizational measures to secure your data, including encryption, access control, and data backups.
      </p>

      <h2 className="text-2xl font-semibold mt-6">9. International Data Transfers</h2>
      <p>
        If data is transferred outside the European Economic Area (EEA), we ensure adequate protection through Standard Contractual Clauses or other legal mechanisms.
      </p>

      <h2 className="text-2xl font-semibold mt-6">10. Children</h2>
      <p>
        We do not knowingly collect data from children under the age of 13. If we become aware of such collection, we will delete the data promptly.
      </p>

      <h2 className="text-2xl font-semibold mt-6">11. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page and, where appropriate, notified by email.
      </p>

      <h2 className="text-2xl font-semibold mt-6">12. Complaints</h2>
      <p>If you believe your data protection rights have been violated, you may contact the Belgian Data Protection Authority:</p>
      <ul className="list-disc ml-6">
        <li><strong>Autorité de protection des données / Gegevensbeschermingsautoriteit</strong></li>
        <li>
          <a
            href="https://www.gegevensbeschermingsautoriteit.be"
            className="text-blue-600 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.gegevensbeschermingsautoriteit.be
          </a>
        </li>
      </ul>

      <p className="mt-6 italic">Last updated: 2025-06-20</p>
    </div>
  );
};

export default PrivacyPolicy;